import { useTeam } from 'app/frontend/base/config/context/team'
import { useAuth } from 'app/frontend/base/config/context/auth'
import RaidPlansOverviewContent from './RaidPlansOverviewContent'
import TeamPlansIntro from './TeamPlansIntro'

const TeamPlansOverview = () => {
  const { team } = useTeam()
  const { accessLevel } = useAuth()

  return (
    <RaidPlansOverviewContent
      owner={{ ownerType: 'team', ownerId: team.id }}
      basePath={`${team.path}/plans`}
      canEdit={accessLevel === 'admin'}
      intro={<TeamPlansIntro eventsPath={`${team.path}/events`} />}
    />
  )
}

export default TeamPlansOverview
